import React, { useEffect, useState } from 'react';
import AUX from '../../../hoc/Aux_';
import { Button } from 'reactstrap';
import Dropdown from '../filters/Dropdown';
import { useDispatch, useSelector } from 'react-redux';
import { getLeavePolicy } from '../../../redux/MainAction';
import AddpolicyModal from './AddpolicyModal';
import PaginationComponent from '../filters/PaginationComponent';

const LeavePolicy = () => {
  const dispatch = useDispatch();
  const [leave, setLeave] = useState([]);
  const policy = useSelector((state) => state?.Webtracker?.leavePolicy);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editID, setEditID] = useState(false);

  const [page, setPage] = useState(1); // Current page
  const [totalPages, setTotalPages] = useState(0); // Total number of pages
  const itemsPerPage = 10;

  useEffect(() => {
    getList();
  }, [page]);

  const getList = () => {
    var data = {
      offset: (page - 1) * itemsPerPage,
      limit: itemsPerPage,
    };
    dispatch(getLeavePolicy(data));
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    if (policy && policy?.rows) {
      setLeave(policy?.rows);
      setTotalPages(Math.ceil(policy.count / itemsPerPage));
    }
  }, [policy]);
  console.log('policy', policy);

  const handleEdit = (id) => {
    setEditID(id);
    toggleModal();
  };

  const handlePageChange = (event, value) => {
    setPage(value);
  };

  return (
    <AUX>
      <div className="page-content-wrapper">
        <div className="col-12 d-flex align-items-center mb-1 ">
          <h5 className="text-muted col-2"></h5>
          <div
            className="col-10 d-flex justify-content-end align-items-center"
            style={{ gap: '20px' }}
          >
            <Button
              className=""
              size="sm"
              color="primary"
              onClick={() => handleEdit(false)}
            >
              + Add Leave Policy
            </Button>
          </div>
        </div>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              {isModalOpen && (
                <AddpolicyModal
                  open={isModalOpen}
                  onClose={toggleModal}
                  editID={editID}
                />
              )}
              <div className="card m-b-20">
                <div className="card-body">
                  <div>
                    <table
                      id="datatable"
                      className="table dt-responsive nowrap table-vertical"
                      width="100%"
                      cellSpacing="0"
                    >
                      <thead>
                        <tr>
                          <th>No.</th>
                          <th>Policy Name</th>
                          <th>Members</th>
                          <th>Policy Type</th>
                          <th>Reason</th>
                          <th>Balance</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {leave?.map((lvs, idx) => (
                          <tr key={idx}>
                            <td>{idx + 1 + (page - 1) * itemsPerPage}</td>
                            <td>{lvs?.name}</td>
                            <td>
                              <div className="mem_container">
                                {lvs?.leavePolicyMembers?.length > 0
                                  ? lvs?.leavePolicyMembers?.map((tms, idx) => (
                                      <span
                                        key={idx}
                                        className="table-team-name text-nowrap"
                                      >
                                        {tms?.employee?.firstName}{' '}
                                        {tms?.employee?.lastName}
                                      </span>
                                    ))
                                  : '--'}
                              </div>
                            </td>
                            <td>
                              <span
                                className={
                                  lvs?.payment === 'PAID'
                                    ? 'rl_status bg-lime text-nowrap'
                                    : 'rl_status bg-purple text-nowrap'
                                }
                              >
                                {lvs?.payment === 'PAID' ? 'Paid' : 'Unpaid'}
                              </span>
                            </td>
                            <td>
                              <span
                                className={
                                  lvs?.reason === 'REQUIRED'
                                    ? 'rl_status bg-warning'
                                    : 'rl_status bg-info'
                                }
                              >
                                {lvs?.reason === 'REQUIRED'
                                  ? 'Required'
                                  : 'Optional'}
                              </span>
                            </td>
                            <td className="text-nowrap">
                              {Math.abs(parseInt(lvs?.duration) || 0)} days
                            </td>
                            <td>
                              <span
                                onClick={() => handleEdit(lvs?.id)}
                                style={{ cursor: 'pointer' }}
                              >
                                <i className="fa fa-pencil font-20"></i>
                              </span>
                            </td>
                          </tr>
                        ))}
                        {/* Add other rows as needed */}
                      </tbody>
                    </table>
                    <PaginationComponent
                      count={totalPages}
                      page={page}
                      onPageChange={handlePageChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AUX>
  );
};

export default LeavePolicy;
